import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Product from "./views/Product";
import WhyInsurance from "./views/WhyInsurance";
import About from "./views/About";
import Article from "./views/Article";
import FAQ from "./views/FAQ";
import Contact from "./views/Contact";
import Checkout from "./views/Checkout";
import CheckoutSummary from "./views/CheckoutSummary";
import Purchase from "./views/Purchase";
import { ThemeProvider } from "@material-tailwind/react";
import PrivacyPolicy from "./views/PrivacyPolicy";
import Cookies from "./views/Cookies";
import Home from "./views/Home";
import OurInsurance from "./views/OurInsurance";
import ProtectedRoute from "./components/ProtectedRoute";
import Payment from "./views/Payment";

const router = createBrowserRouter([
  {
    path: "/:countryCode",
    element: <App />,
    children: [
      {
        index: true,
        path: "",
        element: <Home />,
      },
      {
        path: "our_insurance",
        element: <OurInsurance />,
      },
      {
        path: "product",
        children: [
          {
            index: true,
            element: <ProtectedRoute> <Product/></ProtectedRoute>,
          },
          {
            path: "checkout",
            element:<ProtectedRoute> <Checkout /></ProtectedRoute>, 
          },
          {
            path: "summary",
            element:<ProtectedRoute> <CheckoutSummary /></ProtectedRoute>, 
          },
          {
            path: "payment",
            element:<ProtectedRoute> <Payment /></ProtectedRoute>, 
          },
          {
            path: "purchase",
            element:<ProtectedRoute> <Purchase /></ProtectedRoute>, 
          }
        ],
      },
      /*{
        path: "about",
        element: <About />,
      },*/
      {
        path: "article/:id",
        element: <Article />,
      },      
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "faq",
        element: <FAQ />,
      },
      { path: "why_insurance", element: <WhyInsurance /> },
      { path: "privacy_policy", element: <PrivacyPolicy /> },
      { path: "cookies", element: <Cookies /> }
    ],
  },
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <Home /> },
    ],
  },
]);

// Only allow console logging in 
if (process.env.NODE_ENV !== 'development') {
  console.log = () => {}
  console.error = () => {}
  console.debug = () => {}
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <RouterProvider router={router} />
    </ThemeProvider>
  </React.StrictMode>
);